<a class="card" [routerLink]="routerLink">
  <div osnSharedAspectRatio="{{ aspectRatio }}">
    <img
      class="bg-image d-flex align-items-center justify-content-center"
      [src]="vm.imageUrl"
      osnSharedUseAsPicture
      [imgQuery]="imgQuery"
      [alt]="vm.titleToDisplay"
    />
  </div>
  <p class="title" *ngIf="!vm.imageUrl">{{ vm.titleToDisplay }}</p>
</a>
